import { Divider } from '@heroui/react';
import { useDocumentTitle } from '@hooks/useDocumentTitle';
import { PropertyTable } from './PropertyTable';

export function HistoricalStatus() {
  useDocumentTitle('WPC - Historical Status Lookup');
  return (
    <>
      <h2>Historical Status Lookup</h2>
      <p className="mb-3">
        We have completed the first phase of work our National Register nomination. Below the list of property
        evaluations identifing houses as <em>potential</em> contributors or non-contributors to the future Windsor Park
        historic district.
      </p>
      <p className="mb-3">
        The State Historic Preservation Office (SHPO) has reviewed some of the issues that were specific to the houses
        in this neighborhood, and they were generally supportive of including more of the houses as contributors. As a
        result, there are more contributors identified than we had anticipated, and fewer borderline houses. As of now,
        we have 99 houses identified as contributors, out of a total of 128 properties; that is 77%.
      </p>
      <p className="mb-3">
        This list is subject to review at multiple levels, so it is possible that the status of some houses may change.
      </p>
      <Divider className="mb-3" />
      <PropertyTable />
    </>
  );
}
